var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.33301 12.6703L3.33301 15.7438C3.33301 16.2095 3.5086 16.6562 3.82116 16.9856C4.13372 17.315 4.55765 17.5 4.99967 17.5H14.9997C15.4417 17.5 15.8656 17.315 16.1782 16.9856C16.4907 16.6562 16.6663 16.2095 16.6663 15.7438V12.6703M10.0006 2.5V12.4521M10.0006 12.4521L13.8101 8.64941M10.0006 12.4521L6.19108 8.64941",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadActive);
export default __webpack_public_path__ + "static/media/download-active.3a45d121271756903153466815940387.svg";
export { ForwardRef as ReactComponent };